import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=c970a2be&"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports